import { createFileRoute } from "@tanstack/react-router";
import { useWebhookMutations } from "#app/hooks/settings/use-webhook-mutations";
import { WebhookFormView } from "#app/components/settings/webhook-form-view";
import type { CreateWebhookInput } from "#app/lib/data";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";
import { withPermission } from "#app/components/permissions/require-permission";

function WebhookCreatePage() {
  const { replace } = useAppNavigate();
  const { createWebhook } = useWebhookMutations();

  const navigateBack = () => replace("/settings/api");

  async function handleSubmit(data: CreateWebhookInput) {
    await createWebhook(data);
    navigateBack();
  }

  return (
    <WebhookFormView
      webhook={null}
      onCancel={navigateBack}
      onSubmit={handleSubmit}
    />
  );
}

export const Route = createFileRoute("/(app)/$workspace/settings/api/webhooks/create")({
  component: withPermission("workspace.integrations", WebhookCreatePage),
});
